import { Component, Input, OnChanges, OnInit } from "@angular/core";

@Component({
	selector: "caass-district-calendar-school-table",
	templateUrl: "./district-calendar-school-table.component.html",
	styleUrls: ["./district-calendar-school-table.component.css"],
})
export class DistrictCalendarSchoolTableComponent implements OnInit, OnChanges {
	constructor() {}

	ngOnInit() {
		this.UpdateData();
	}

	ngOnChanges() {
		this.UpdateData();
	}

	//////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////

	@Input() lstSchool: any = [];
	SelectedSchools: any = [];

	lstSchoolTypeDesc: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	cols: any = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
		{ field: "SchoolTypeDesc", header: "School Type" },
	];

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////

	UpdateData() {
		this.lstSchoolTypeDesc = Array.from(new Set(this.lstSchool.map((item: any) => item.SchoolTypeDesc))).sort();
	}

	//////////////////////////////////////////////////////////////////////
}
